// @flow

import $ from 'jquery'

export default class DownloadLink {
  static init () {
    $('a.download-link').each(function () {
      $(this).attr('download', '')
    })
  }
}
